import axios from 'axios';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ApiEndPoint,} from "./api_end_point";
import StringUtils from '../utils/string_utils';

export const getToken =()=>{
  let token=localStorage.getItem('token');
        if(token){
            token=token.slice(1,-1);
        }
        else{
            const userdata = localStorage.getItem('userData');
            const parsedUserData= JSON.parse(userdata);
            token= parsedUserData.token;
        }
    return token;
}


const apiEndPoint = new ApiEndPoint();
const refreshToken = async () => {
  try {

    let rtoken = localStorage.getItem('rtoken');

    if (!rtoken) {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        rtoken = parsedUserData.refreshToken;
      }
    }

    if (!rtoken) {
      throw new Error('No refresh token found');
    }

    const response = await axios.post(
        apiEndPoint.authBaseUrl + apiEndPoint.refResToken,
        {
          refresh_token: rtoken.replace(/"/g, '')
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
    );

    if (response.status === 200) {
      const newAccessToken = response.data.data.access_token;
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        parsedUserData.token = newAccessToken;
        localStorage.setItem('userData', JSON.stringify(parsedUserData));
      } else {
        localStorage.setItem('token', JSON.stringify(newAccessToken));
      }
    }
  } catch (error) {
    throw new Error('Error refreshing token: ' + error);
  }
};

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const response = error.response;
      if (response && (response.status === 401||response.status === 403) && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          await refreshToken();
          const userData = localStorage.getItem('userData');
          let token;

          if (userData) {
            const parsedUserData = JSON.parse(userData);
            token = parsedUserData.token;
          } else {
            token = localStorage.getItem('token');
          }
          if (token) {

            if ((token.startsWith('"') && token.endsWith('"')) || (token.startsWith("'") && token.endsWith("'"))) {
              token = token.slice(1, -1);
            }
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return axios(originalRequest);
          }
        }
        catch (refreshError) {
          if (refreshError.response && refreshError.response.status === 401) {
            console.error('Refresh token failed:', refreshError);
            toast.error('Session expired. Please login again.', { autoClose: 3000 });
          }
          throw refreshError;
        }
      }
      else if (response && response.status === 400) {
        const backendErrorMessage = response.data?.message || "Bad Request";
        console.log(backendErrorMessage);
        throw new Error(backendErrorMessage);
      }
      return Promise.reject(error);
    }
);

export const apiCaller = async (apiUrl,additionalInfo = {})=>{
  try{
    const { method='GET', headers = {}, data = null, params = {} } = additionalInfo;
    const response =await axios({
      url:apiUrl,
      method: method,
      headers: headers,
      data: data,
      params: params
    })

    if ((response) && (response.status >= 200 || response.status < 300)) {
      return response.data;
    }
    if( response.status === 401 || response.status === 400){
      toast.error('Error: Unauthorized or Bad Request', {
        position: toast.POSITION.TOP_CENTER, // For middle-top of the screen
        autoClose: 2000, // The toast will auto-close after 5 seconds
      });
    }
    if (response.status === 404) {
      throw new Error("Not Found");
    }
    if (response.status === 500) {
      throw new Error("Internal Server Error");
    }
    if (response.status === 408) {
      throw new Error("Try after some time");
    }
  }
  catch (e){
    throw new Error(e);
  }
}

export const fileDownloader = async ({
    url,
    fileName = "download",
    fileType = "pdf",
}) => {
    try {
        const token = getToken();
        const response = await axios({
            url,
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: `application/${fileType}`,
            },
        });
        const blob = new Blob([response.data], { type: `application/${fileType}` });
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${fileName}.${fileType}`;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(downloadUrl);

        return true;
    } catch (error) {
        throw new Error(StringUtils.downloadFileFailed + error);
    }
};